module.exports = __webpack_public_path__ + "static/media/banner-dot.742b20af.svg";